import React from 'react';
import LinkTreeManager from '../../Links/LinkTreeManager';

export default function LinktreeSection({
    data,
    onStorefrontChanged,
    wrapperElement = 'section',
}) {
    return (
        <LinkTreeManager
            storefrontUrl={data?.url}
            showPreview={false}
            onChanged={onStorefrontChanged}
            wrapperElement={wrapperElement}
        />
    );
}
